export default __webpack_public_path__ + "static/media/prevImage.84988c04.svg";